<template>
    <div>
        <div v-for="(item, i) in this.order.items">
            <div class="prodotto">
                <div class="row">
                    <div class="col-sm-9 col-md-10">
                        <div class="quantita">
                            {{item.quantity}}
                        </div>
                        <div class="nome">
                            <router-link
                                    :to="{name:'menu.category.product',params:{id:item.item.id,category_id:item.item.category_id},query:{idx:i}}"
                                    class="a3">
                                {{item.item.nome}}
                              <img src="/img/be/ico-nodiscount.png" width="20" class="ml-2" v-if="coupon && !item.item.f_sconto"/>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-sm-3 col-md-2">
                        <div class="prezzo">
                            {{(item.quantity * item.single_cost).toFixedGood(2)}} {{locale_currency}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="opzioni">
                <div class="note" v-if="item.item.note">
                    <span>{{$t('note')}}:</span> {{item.item.note}}
                </div>
                <div class="misura d-flex justify-content-between"
                     v-if="!item.item.f_prodotto_composto || item.item.prodotto_composto_tipo_prezzo === 'FISSO'">
                    <div v-if=" item.item.f_prodotto_composto">
                        {{$t('prezzo_fisso')}}
                    </div>
                    <div v-else>
                        {{$t('ordine.misura')}}: {{item.item.proportion.nome}}
                    </div>
                    <span>{{item.item.proportion.prezzo.toFixedGood(2)}} {{locale_currency}}</span>
                </div>
                <div class="misura" v-if="item.item.variant">
                    {{$t('ordine.variante_titolo')}} : {{item.item.variant.nome}}
                    <span v-if="item.item.variant.prezzo !== undefined">
                        {{((item.item.variant.prezzo < 0) ? " - " : " + ")}}
                        {{Math.abs(item.item.variant.prezzo).toFixedGood(2)}}
                        {{locale_currency}}
                    </span>
                </div>
                <ul v-if="item.item.free_picks.length">
                    <li v-for="pick in getProductFreePicksGroup(item.item.free_picks)">
                        {{pick[0].alias}} ({{$t("qta")}}: {{pick.length}})
                        <span>
                        {{((pick[0].variazione_prezzo < 0) ? " - " : " + ")}}
                        {{Math.abs(pick.map((item) => item.variazione_prezzo).reduce((a, b) => a + b, 0)).toFixedGood(2)}}
                        {{locale_currency}}
                    </span>
                    </li>
                </ul>
                <ul v-if="item.item.adds.length">
                    <li v-for="add in item.item.adds">
                        {{$t('aggiunta')}}: {{add.alias}}
                        <span>
                            {{((add.variazione_prezzo < 0) ? " - " : " + ")}}
                            {{Math.abs(add.variazione_prezzo).toFixedGood(2)}}
                            {{locale_currency}}
                        </span>
                    </li>
                </ul>
                <ul v-if="item.item.prodotto_composto_associati.length">
                    <li v-for="associated in item.item.prodotto_composto_associati">
                        {{associated.nome_prodotto}} ({{$t("qta")}}: {{associated.qta}})
                        <span v-if="associated.prezzo">
                            {{((associated.prezzo < 0) ? " - " : " + ")}}
                            {{Math.abs(associated.prezzo).toFixedGood(2)}}
                            {{locale_currency}}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex'

    export default {
        name: "IncCartProducts",
        props: ["coupon"],
        computed: {
            ...mapState('order', {
                order: state => state
            }),
            ...mapGetters('order', {
                getProductFreePicksGroup: 'getProductFreePicksGroup'
            }),
            ...mapGetters('restaurant', {
                locale_currency: 'localeCurrency'
            })
        }
    }
</script>
